module.exports = ".bottom {\n  position: absolute;\n  bottom: 0;\n  height: 2em;\n  width: 100%;\n}\n\n.mid {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: calc(100px + 1em);\n  bottom: 3em;\n}\n\n.top {\n  height: 100px;\n  width: 100%;\n  position: absolute;\n  top: 0;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main